import styles from './headcount-charts.module.scss';
import React from 'react';
import { addThousandSeparator } from 'utils/numbers';
import { useTranslation } from 'react-i18next';
import { getFormatSeparatorsOptions } from 'config/marketConfig';
import { weakKey } from 'utils/objects';

export default function HeadcountCharts(props) {
  const { currentWorkforce, projectedWorkforce } = props;
  const { totalHeadcount } = projectedWorkforce;
  const { t } = useTranslation();
  const typesOfWorkplace = [
    {
      title: t('step6.inOffice'),
      values: { current: currentWorkforce.office, projected: projectedWorkforce.office },
    },
    {
      title: t('step6.remote'),
      values: { current: currentWorkforce.remote, projected: projectedWorkforce.remote },
    },
    {
      title: t('step6.hybrid'),
      values: { current: currentWorkforce.hybrid, projected: projectedWorkforce.hybrid },
    },
  ];

  const definePercentage = (total, current) => {
    return (current / total) * 100 + '%';
  };

  return (
    <div>
      <div className={styles.headcount__charts_wrapper}>
        {typesOfWorkplace.map((type) => {
          return (
            <div key={weakKey(type)} className={styles.headcount__charts_container}>
              <span className={styles.headcount__charts_title}>{type.title}</span>
              <div className={styles.headcount__charts}>
                <div className={styles.headcount__chart_container}>
                  <div
                    style={{
                      width: definePercentage(totalHeadcount, type.values.current),
                    }}
                    className={styles.headcount__chart}></div>
                  <span className={styles.headcount__chart_value}>
                    {addThousandSeparator(type.values.current, getFormatSeparatorsOptions())}
                  </span>
                </div>
                <div className={styles.headcount__chart_container}>
                  <div
                    style={{
                      width: definePercentage(totalHeadcount, type.values.projected),
                    }}
                    className={`${styles.headcount__chart} ${styles.headcount__chart_projected}`}></div>
                  <span className={styles.headcount__chart_value}>
                    {addThousandSeparator(type.values.projected, getFormatSeparatorsOptions())}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.headcount__chart_years_container}>
        <div className={styles.headcount__chart_year}>
          <div className={styles.headcount__chart_year_mark}></div>
          {t('step6.startYear')} : {currentWorkforce.year}
        </div>
        <div className={styles.headcount__chart_year}>
          <div
            className={`${styles.headcount__chart_year_mark} ${styles.headcount__chart_year_mark_projected}`}></div>
          {t('step6.endYear')} : {projectedWorkforce.year}
        </div>
      </div>
    </div>
  );
}
